import httpService from "./httpService";

export type ConfigValue = string | number | boolean;
export type UserSettingsData = Record<string, ConfigValue>;
export type ConfigData = Record<string, ConfigValue | UserSettingsData>;

export interface UserConfiguration {
  id: string;
  userId: string;
  ibkrAccountId: string | null;
  data: ConfigData | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserConfigurationDto {
  userId: string;
  ibkrAccountId?: string | null;
  data?: ConfigData | null;
}

export interface UpdateUserConfigurationDto {
  ibkrAccountId?: string | null;
  data?: ConfigData | null;
}

const userConfigurationService = {
  getUserConfiguration: async (userId: string): Promise<UserConfiguration> => {
    const response = await httpService.get(`/v2/admin/user-configurations/${userId}`);
    return response.data;
  },

  createUserConfiguration: async (data: CreateUserConfigurationDto): Promise<UserConfiguration> => {
    const response = await httpService.post("/v2/admin/user-configurations", data);
    return response.data.configuration;
  },

  updateUserConfiguration: async (userId: string, data: UpdateUserConfigurationDto): Promise<UserConfiguration> => {
    const response = await httpService.put(`/v2/admin/user-configurations/${userId}`, data);
    return response.data.configuration;
  },

  deleteUserConfiguration: async (userId: string): Promise<void> => {
    await httpService.delete(`/v2/admin/user-configurations/${userId}`);
  },
};

export default userConfigurationService;
